exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gitlab-project-list-screen .project-avatar {\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n}\n", ""]);

// exports
